import Vue from 'vue'
import Router from 'vue-router'
import Header from '../components/Head.vue'
import Index from '../components/Index.vue'
import Smart from '../components/Smart.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Header',
      component:Header
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js